const data = {
  nodes: [{
    id: '0',
    type: 'head-sql',
    name: '开始',
    isHeader: true,
    router: '/incoming-order',
    color: '#88A067',
  }, {
    id: '01',
    type: 'sql',
    name: '创建来料订单',
    router: '/incoming-order/create',
    color: '#5B8FF9',
  },
    {
      id: '02',
      type: 'sql',
      name: '来料入库(手持设备)',
    },
    {
      id: '03',
      type: 'sql',
      name: '来料出库(手持设备)',
    },
    {
      id: '04',
      type: 'sql',
      name: '测试(测试机)',
    },
    {
      id: '05',
      type: 'sql',
      name: '成品入库(手持设备)',
    },
    {
      id: '06',
      type: 'sql',
      name: '发货建单',
      router: '/delivery-order',
      color: '#45B0B6',
    },
    {
      id: '07',
      type: 'sql',
      name: '关联箱子(手持设备)',
    },
    {
      id: '08',
      type: 'sql',
      name: '发货操作',
      router: '/delivery-operation',
      color: '#A7BE79'
    },
    {
      id: '09',
      type: 'sql',
      name: '扫描快递单(手持设备)',
    },
    {
      id: '10',
      type: 'sql',
      name: '扫描回签单',
      router: '/scan-return-ticket',
      color: '#D56863'
    },
    {
      id: '11',
      type: 'tail-sql',
      name: '结束',
      isTail: true,
      color: '#E6A23C',
    }],
  edges: [{
    source: '0',
    target: '01',
    data: {
      color: '#5B8FF9',
    }
  }, {
    source: '01',
    target: '02'
  },
    {
      source: '02',
      target: '03'
    },
    {
      source: '03',
      target: '04'
    },
    {
      source: '04',
      target: '05'
    },
    {
      source: '05',
      target: '06',
      data: {
        color: '#45B0B6',
      }
    },
    {
      source: '06',
      target: '07'
    },
    {
      source: '07',
      target: '08',
      data: {
        color: '#A7BE79',
      }
    },
    {
      source: '08',
      target: '09'
    }, {
      source: '09',
      target: '10',
      data: {
        color: '#D56863',
      }
    }, {
      source: '10',
      target: '11'
    }]
};

export default data;
